import * as actions from './actions'
import * as epics from './epics'
import reducers from './reducers'

// TODO: fill out with actions, etc
export default {
  actions,
  epics,
  reducers,
}
